import {
  getEngineApiClient,
  encodeArrayAsQueryString
} from '../../api-client/axios-client.js'

const state = {
  titles: [],
  counties: [],
  currencies: [],
  airports: []
}

const getters = {
  getEuroCurrency(state) {
    if (state.currencies.length > 0) {
      return state.currencies.find(cur => cur.currencyCode === 'EUR')
    }
  }
}

const mutations = {
  setAirports(state, payload) {
    state.airports = payload
  },
  setCounties(state, payload) {
    state.counties = payload
  },
  setCurrencies(state, payload) {
    state.currencies = payload
  },
  setTitles(state, payload) {
    state.titles = payload
  }
}

const actions = {
  async initAirports({ commit, state, dispatch }) {
    if (state.airports && state.airports.length > 0) {
      return
    }

    // get airports from api
    const client = getEngineApiClient()
    try {
      const airportCodes = process.env.VUE_APP_AIRPORT_CODES.split(',')
      const airportCodesQuery = encodeArrayAsQueryString(
        airportCodes,
        'airportCodes'
      )
      const response = await client.get(`/Cache/Airports?${airportCodesQuery}`)
      commit(
        'setAirports',
        response.data.sort((a, b) => a.name.localeCompare(b.name))
      )
    } catch (error) {
      dispatch('setFatalError', error)
    }
  },
  async initCounties({ commit, state, dispatch }) {
    if (state.counties && state.counties.length > 0) {
      return
    }

    // get counties from api
    const client = getEngineApiClient()
    try {
      const response = await client.get('/Cache/Counties?enabled=true')
      commit('setCounties', response.data)
    } catch (error) {
      dispatch('setFatalError', error)
    }
  },
  async initCurrencies({ commit, state, dispatch }) {
    if (state.currencies && state.currencies.length > 0) {
      return
    }

    // get counties from api
    const client = getEngineApiClient()
    try {
      const response = await client.get('/Cache/Currencies')
      commit('setCurrencies', response.data)
    } catch (error) {
      dispatch('setFatalError', error)
    }
  },
  async initTitles({ commit, state, dispatch }) {
    if (state.titles && state.titles.length > 0) {
      return
    }

    // get titles from api
    const client = getEngineApiClient()
    try {
      const response = await client.get('/Cache/Titles', {
        headers: {
          'Content-Type': null
        }
      })
      commit('setTitles', response.data)
    } catch (error) {
      dispatch('setFatalError', error)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
